export const typeOfCoverageList = [
  { text: 'Employer Group', value: 'employer_group' },
  { text: 'Individual', value: 'individual' },
  { text: 'Medicare', value: 'medicare' },
  { text: 'Governmental', value: 'governmental' }
]
